module.exports = __webpack_public_path__ + "img/bgSecondBar.5d521849.png";